import { Drawer } from '@mui/material';
import React from 'react';

import NavBar from './NavBar';

type MobileNavDrawerProps = {
  container: Element;
  mobileOpen: boolean;
  handleDrawerClose: () => void;
  handleDrawerTransitionEnd: () => void;
  drawerWidth: number;
};

export default function MobileNavDrawer(props: MobileNavDrawerProps) {
  return (
    <Drawer
      container={props.container}
      variant='temporary'
      open={props.mobileOpen}
      onTransitionEnd={props.handleDrawerTransitionEnd}
      onClose={props.handleDrawerClose}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: { xs: 'block', sm: 'none' },
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: props.drawerWidth,
          backgroundColor: 'primary.dark',
        },
      }}
    >
      <NavBar />
    </Drawer>
  );
}
